/** @format */

import React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Actions from "../../../components/actions";
import Defects from "../../../components/defects";
import Complaint from "../../../components/complaint";
import Parts from "../../../components/part";
import ServiceEngineers from "../../../components/service-engineers";
import MailingList from "../../../components/mailing-list";
import Oems from "../../../components/oems";
import OemNames from "../../../components/oem-names";
import Users from "../../../components/users";
import Products from "../../../components/products";
import BestPerformer from "../../../components/best-performer";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div hidden={value !== index} {...other}>
      {value === index && <Box sx={{ p: 1 }}>{children}</Box>}
    </div>
  );
}

const Setup = () => {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Box>
        <Tabs
          value={value}
          onChange={handleChange}
          scrollButtons
          variant="scrollable"
          allowScrollButtonsMobile
          sx={{
            marginTop: "10px",
            minHeight: "auto",
            "& .MuiTabs-flexContainer": {
              minHeight: "32px",
            },
          }}
        >
          {[
            "User Accounts",
            "Actions",
            "Defects",
            "Complaint",
            "Parts",
            "Oem Accounts",
            "Oem Org",
            "Mailing List",
            "Products",
            "Performer",
          ].map((label, index) => (
            <Tab
              key={index}
              label={label}
              sx={{
                minHeight: "32px",
                fontSize: "12px",
                padding: "6px 12px",
              }}
            />
          ))}
        </Tabs>
      </Box>

      <TabPanel value={value} index={0}>
        <Users />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <Actions />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <Defects />
      </TabPanel>
      <TabPanel value={value} index={3}>
        <Complaint />
      </TabPanel>
      <TabPanel value={value} index={4}>
        <Parts />
      </TabPanel>
      <TabPanel value={value} index={5}>
        <Oems />
      </TabPanel>
      <TabPanel value={value} index={6}>
        <OemNames />
      </TabPanel>
      <TabPanel value={value} index={7}>
        <MailingList />
      </TabPanel>
      <TabPanel value={value} index={8}>
        <Products />
      </TabPanel>
      <TabPanel value={value} index={9}>
        <BestPerformer />
      </TabPanel>
    </Box>
  );
};

export default Setup;
